import type { ImportRowDedupeResult } from './importTable'
import { createId } from './id'

export const toStableImportIdString = (value: unknown): string => {
  if (typeof value === 'string' || typeof value === 'number') {
    return String(value).trim()
  }
  return ''
}

export const ensureUniqueImportedRowId = (args: {
  row: Record<string, unknown>
  existingIds: Set<string>
  importedIds: Set<string>
  idPrefix: string
}): ImportRowDedupeResult => {
  const rawId = toStableImportIdString(args.row.id)
  let finalId = rawId
  let reason: ImportRowDedupeResult['reason'] = 'accepted'

  if (!rawId) {
    finalId = createId(args.idPrefix)
    reason = 'missing'
  } else if (args.existingIds.has(rawId)) {
    finalId = createId(args.idPrefix)
    reason = 'existing'
  } else if (args.importedIds.has(rawId)) {
    finalId = createId(args.idPrefix)
    reason = 'duplicate'
  }

  args.row.id = finalId
  args.importedIds.add(toStableImportIdString(args.row.id))

  return {
    requestedId: rawId,
    finalId: toStableImportIdString(args.row.id),
    reason
  }
}